/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AssistantToolsetRef = {
  /**
   * Optional environment slug used when invoking the toolset.
   */
  environmentSlug?: string | undefined;
  /**
   * The toolset slug exposed to the assistant.
   */
  toolsetSlug: string;
};

/** @internal */
export const AssistantToolsetRef$inboundSchema: z.ZodMiniType<
  AssistantToolsetRef,
  unknown
> = z.pipe(
  z.object({
    environment_slug: z.optional(z.string()),
    toolset_slug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "environment_slug": "environmentSlug",
      "toolset_slug": "toolsetSlug",
    });
  }),
);
/** @internal */
export type AssistantToolsetRef$Outbound = {
  environment_slug?: string | undefined;
  toolset_slug: string;
};

/** @internal */
export const AssistantToolsetRef$outboundSchema: z.ZodMiniType<
  AssistantToolsetRef$Outbound,
  AssistantToolsetRef
> = z.pipe(
  z.object({
    environmentSlug: z.optional(z.string()),
    toolsetSlug: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      environmentSlug: "environment_slug",
      toolsetSlug: "toolset_slug",
    });
  }),
);

export function assistantToolsetRefToJSON(
  assistantToolsetRef: AssistantToolsetRef,
): string {
  return JSON.stringify(
    AssistantToolsetRef$outboundSchema.parse(assistantToolsetRef),
  );
}
export function assistantToolsetRefFromJSON(
  jsonString: string,
): SafeParseResult<AssistantToolsetRef, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AssistantToolsetRef$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AssistantToolsetRef' from JSON`,
  );
}
